import React from "react";

const NotFound = () => {
  return <h1>404 error page!</h1>;
};

export default NotFound;
